import { emptyUiLayout, normalizeUiLayout, type UiLayout, type UiLayoutGateway } from './uiLayout';

/**
 * Layout je Mandant + Seite im Browser. Bewusst hinter dem async-Gateway (wie das Firmenprofil), damit
 * der Umzug in die Supabase-Tabelle nur ein Austausch der Implementierung ist. HINWEIS: localStorage
 * ist geräteweit — für ein wirklich mandantenweit GETEILTES Layout ist die Supabase-Variante nötig;
 * diese hier trägt Demo/Session-Modus.
 */
const storageKey = (tenantId: string, pageKey: string) => `forq.tenant.ui-layout.${tenantId}.${pageKey}.v1`;

export class LocalUiLayoutGateway implements UiLayoutGateway {
  async loadLayout(tenantId: string, pageKey: string): Promise<UiLayout> {
    try {
      const raw = globalThis.localStorage?.getItem(storageKey(tenantId, pageKey));
      return raw ? normalizeUiLayout(JSON.parse(raw)) : emptyUiLayout;
    } catch {
      return emptyUiLayout;
    }
  }

  async saveLayout(tenantId: string, pageKey: string, layout: UiLayout): Promise<UiLayout> {
    const normalized = normalizeUiLayout(layout);
    try {
      globalThis.localStorage?.setItem(storageKey(tenantId, pageKey), JSON.stringify(normalized));
    } catch {
      throw new Error('Das Layout konnte nicht gespeichert werden.');
    }
    return normalized;
  }
}

export function createLocalUiLayoutGateway(): UiLayoutGateway {
  return new LocalUiLayoutGateway();
}
